import { getCookie, removeCookie } from '@/utils/cookie';
import axios from 'axios';
import { Message } from 'element-ui';
import router from './router';
import store from '@/common/vuex';

// axios.defaults.withCredentials = true
axios.defaults.crossDomain = true;
axios.defaults.timeout = 15000;

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
    config => {
        if (!config.passtoken) {
            let params = {
                'app-login-channel': 'xdSaaSbd',
                'auth-token': getCookie('token')
            };
            if (getCookie('X-Hades-Env-Identity')) {
                params['X-Hades-Env-Identity'] = getCookie(
                    'X-Hades-Env-Identity'
                );
            }
            config.headers = {
                ...config.headers,
                ...params
            };
        }
        if (config.signout) {
            config.headers['Content-Type'] =
                'application/x-www-form-urlencoded';
        }
        config.errorOrigin = config.errorOrigin || '';
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

/**
 * 响应器
 */
axios.interceptors.response.use(
    response => {
        if (response && response.data) {
            switch (response.data.code) {
                case 401:
                case 403:
                case '401':
                case '403':
                    // 返回 401 清除token信息并跳转到登录页面
                    removeCookie('token', {
                        domain: location.hostname.replace(/.*?\./, '')
                    });
                    if (store.getters.userInfo.dccTenantAjmdLogoutUrl) {
                        window.location.href =
                            store.getters.userInfo.dccTenantAjmdLogoutUrl;
                    } else {
                        router.replace({
                            path: '/login'
                        });
                    }
            }
        }
        return response;
    },
    error => {
        return Promise.reject(error.response.data); // 返回接口返回的错误信息
    }
);

export const request = options => {
    let { method = 'get' } = options;
    return new Promise((resolve, reject) => {
        if (method.toUpperCase === 'GET') {
            options.params = options.params ? options.params : options.data;
        }
        return axios(options)
            .then(response => {
                const { request, data, config } = response;
                const { responseType } = request;
                const { success } = data;
                if (responseType === 'arraybuffer') {
                    resolve(response);
                } else if (success) {
                    resolve(data);
                } else {
                    if (config.isPassUrl) {
                        resolve(data);
                    } else {
                        // reject，页面业务catch处理  errorHandler 非业务统一处理
                        // 默认系统错误提示，非业务逻辑错误提示
                        if (config.errorOrigin === 'sysn') {
                            Message.error(data.message || '系统错误，请重试');
                            reject(response);
                        } else {
                            reject(response.data);
                            errorHandler(response);
                        }
                    }
                }
            })
            .catch(error => {
                const { message: msg = '' } = error;
                reject(error);
                Message.error({
                    message: msg ? msg : '系统异常'
                });
            });
    });
};

/**
 * 错误接口处理
 * @param error
 */
function errorHandler(response) {
    const { data } = response;
    Message.error({
        message: data ? data.message || data.msg : '系统异常'
    });
}
